import React, { useState } from "react";
import axios from "axios";
import { decryptToken } from "../utils/getToken";

const FaqForm = ({ refresh }) => {
  const [heading, setHeading] = useState("");
  const API = "";
  const token = decryptToken("accessToken") || "";

  const submit = async () => {
    if (!heading.trim()) return alert("Heading required");
    await axios.post(
      `${API}/faq`,
      { heading },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setHeading("");
    refresh();
  };

  return (
    <div className="faq-form">
      <input
        placeholder="FAQ Heading"
        value={heading}
        onChange={(e) => setHeading(e.target.value)}
      />
      <button onClick={submit}>Create FAQ</button>
    </div>
  );
};

export default FaqForm;
